import { axios } from '@Root/API'

export const edit = (id, payload) => {
	return axios.post(`attache/file/${id}/student-course-session`, payload, {
		headers: {
			'Content-Type': 'multipart/form-data',
		},
	})
}
